import {Button, CircularProgress} from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import type {FC, ReactElement, ReactNode, MouseEventHandler} from 'react'

interface BasicExportExcelButtonProps {
  isLoading?: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
  label: ReactNode
  dataTestId?: string
  disabled?: boolean
}

const BasicExportExcelButton: FC<BasicExportExcelButtonProps> = ({
  isLoading = false,
  onClick,
  label,
  dataTestId,
  disabled = false,
}): ReactElement => {
  return (
    <Button
      variant="contained"
      startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : <DownloadIcon />}
      onClick={onClick}
      disabled={isLoading || disabled}
      data-testid={dataTestId}
    >
      {label}
    </Button>
  )
}

export default BasicExportExcelButton
